import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ResultsAppealList from '../../modules/admin/components/ResultsAppeal/ResultsAppealList';

const ResultsAppeal = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('appeal->>ResultsAppeal.Results Appeal')} />

      <ResultsAppealList />
    </>
  );
};

export default ResultsAppeal;
